<template>
	<q-modal v-model="interactiveModal" :content-css="contentCSS">
		<div class="iframe-container">
			<iframe id="interactiveIframe" :src="getInteractiveUrl" allowfullscreen></iframe>
			<q-btn v-if="posterMode" class="q-mt-md float-right poster-btn" label="Set Poster Image" dense color="simpleshow" @click="setPosterImage()"></q-btn>
		</div>
	</q-modal>
</template>

<script>
	export default {
		name: 'InteractiveModal',
		props: {
			showInteractiveModal: {
				type: Boolean,
				default: false
			},

			project: {
				type: Object,
				default() {
					return {};
				}
			},

			languageCode: {
				type: String,
				default: ''
			},

			// language: {
			// 	type: String,
			// 	default: ''
			// },

			posterMode: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				contentCSS: {
					width: '80vw',
					height: '45vw' /* 80/45 = 1.778 */,
					maxHeight: '80vh',
					maxWidth: '142.22vh' /* 16/9 * 80 = 142.22 */,
					backgroundColor: 'rgba(255, 255, 255, 1)',
					borderRadius: '6px'
				}

				// opened: false
			};
		},

		computed: {
			interactiveModal: {
				get: function () {
					return this.showInteractiveModal;
				},

				set: function (newValue) {
					this.$emit('closeInteractive');
				}
			},

			getInteractiveUrl() {
				if (this.project.hash_id !== undefined) {
					return '/storage/projects/data/' + this.project.hash_id + '/' + this.languageCode + '/index.html';
				} else {
					return '/404';
				}
				// return '/storage/projects/data/ZmKQaE8QPe/en_US/index.html';
			}
		},

		methods: {
			setPosterImage() {
				console.log('click');
				this.$html2canvas(document.getElementById('interactiveIframe'), { logging: true })
					.then(function (canvas) {
						console.log('DONE!');
						document.body.appendChild(canvas);
					})
					.catch(function (data) {
						console.log('Error: ' + data);
					});
			}
		}
	};
</script>

<style lang="scss" scoped>
	/* ########## InteractiveModal.vue ########## */
	.iframe-container iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border: 0;
	}
</style>
